import React, {
    useState,
    useEffect,
    useCallback,
} from 'react'
import PropTypes from 'prop-types'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import classNames from 'classnames'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import NumberFormat from 'react-number-format';
import SimpleBar from 'simplebar-react'
import Parser from 'html-react-parser';
import 'simplebar/dist/simplebar.min.css';  
// import { useHistory } from "react-router-dom";

// hooks
import useWindowSize from '../../../../Hooks/useWindowSize'
// import useRouter from 'Hooks/useRouter'
// import useLockBodyScroll from 'Hooks/useLockBodyScroll'
// import useScrollTop from 'Hooks/useScrollTop'

// Atoms
import Button, { ButtonCategory } from '../../../Atoms/Button'
// import Dropdown from './../../../Atoms/Dropdown'
import SearchField from '../../../Atoms/SearchField'
import Title, { TitleTag, TitleStyle } from '../../../Atoms/Title';
import InputSelect, { InputSelectType } from '../../../Atoms/InputSelect';

// Mol
// import PlayPlanCardMol from './../../../Molecules/Cards/Plan/Play'
// import BreadcrumbMol from 'Components/Molecules/Breadcrumb'
import RangeSlider from '../../../Molecules/RangeSlider'
import PaginationMol from '../../../Molecules/Pagination'

// Sass
// import '../../../../Sass/includes/Components/modules/C23.sass'

import C25PeopleOrg from '../C25v2'
import General2OneCardForMonths from '../../../Molecules/Cards/Plan/General2OneCardForMonths';

const C23Filtercollapse = (props) =>{

    const {
        init= true, 
        className,
        cond,
        setCond,
        velocidadesInternet,
        checkedSelectedVelocity,
        filterPlansByInternetVelocity,
        itemEvent,
        getPlanesByCheckBox,
        canalContext

    } = props

    return (
        <div className={`c23FilterBlock c23FilterBlockCollapse ${cond ? 'c23FilterBlockHidden':''} ${className}`}>
            <>
                        {/* <div className='c23FilterBlock'> */}
                        <div className='c23FilterSubtitle' onClick={()=>setCond(c=>!c)}>
                            <p>
                                Velocidad de Internet
                            </p>
                            <i className={`${cond ? 'ico-chevron-down': 'ico-chevron-up'}`}></i>
                        </div>
                        <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                            <div className='c23FakeBtnGroup'>
                                {
                                    velocidadesInternet.map((velocidad, index) => {
                                        return (
                                            <div key={"velocidad"+index} className='fakeBtn'>
                                                <input type='checkbox' checked={velocidad.checked} onChange={(e) => {checkedSelectedVelocity(e, velocidad.valor);  if(itemEvent){getPlanesByCheckBox(itemEvent.e, itemEvent.item, canalContext?.canal, canalContext?.context, velocidad.valor)}else{filterPlansByInternetVelocity(velocidad.valor, null, canalContext?.canal, canalContext?.context)}}} name="velInt" onClick={() => {}} />
                                                <span className='checkmark'></span>
                                                <label>{velocidad.valor}</label>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                                
                        {/* </div> */}
                    </>
        </div>
    )
}  

const C23Filtercollapse2 = (props) =>{

    const {
        init= true, 
        className,
    } = props

    
    const [cond, setCond] = useState(init )

    return (
        <div className={`c23FilterBlock c23FilterBlockCollapse ${cond ? 'c23FilterBlockHidden':''} ${className}`}>
            {props.render(cond, setCond)}
        </div>
    )
}   

const ServiceFilter = React.memo((props) => {
    const {
        setCounterVelocityFilters,
        setCounterChannelFilters,
        velocidadesInternet, setVelocidadInternet,
        checkboxes,
        setCheckboxes,
        canalContext,
        setCanalContext,
        dataChannelsBk,
        onSubmit,
        filterPlansByChannels,
        showFilter,
        setShowFilter,
        // optionsOrder,
        // dataRegiones,
        // optionsRegiones,
        dataFilterTypes,
        dataFilterTypesChilds,
        // dataFilterTypesHead,
        // rangePrice,
        handleChangeFilterPrice,
        // getPlanesByComuna,
        getPlanesByCheckBox,
        getPlanesByCheckBoxChilds,
        // getPlanesByCheckBoxHead,
        // keysTypeCompare,
        counterFilters,
        clearFilters,
        filterPlansByInternetVelocity,
        dataCPlanesBk,
        dataCPlanes
    } = props



    // const router = useRouter()
    const {
        width: widthWindow,
    } = useWindowSize()

    const [rangePrice] = useState(props.rangePrice)
    // console.log("ServiceFilter rangePrice ", rangePrice)

    // const [dataComunas, setDataComunas] = useState([])

    const schemaFilter = yup.object().shape({
        // rangeMin: 
        //     yup.number()
        //         .typeError('El rango minimo solo puede contener números')
        //         .min(10, 'El rango minimo debe ser igual o mayor que 10'),
        // rangeMax: 
        //     yup.number()
        //         .typeError('El rango maximo solo puede contener números')
        //         // .matches(/[0-9]+/gi, "Enter number only")
        //         // .length(3, 'Mas de 3'),
    });

    // const {
    //     paymentType: paymentTypeQuery , 
    //     paymentMethod : paymentMethodQuery,
    //     option: optionQuery,
    // } = router.query

    // console.log('query: ', router.query)

    const {
        register,
        handleSubmit,
        // watch, 
        // errors, 
        // getValues,  
        // control,
        setValue,
        //formState, 
        unregister
    } = useForm({
        defaultValues: {
            minPrice: '',
            maxPrice: '',
            // typePlan: [],
            region: null,
            zone: null,
        },
        resolver: yupResolver(schemaFilter),
    });
    // 
    // const WatchAllFields = watch()
    // console.log(WatchAllFields)
    // useEffect(()=>{
    //     console.log('Valores cambiando de los filtros', WatchAllFields);
    // },[WatchAllFields]) 

    useEffect(() => {
        register("minPrice"); // custom register minPrice input
        register("maxPrice"); // custom register maxprice input
        return () => {
            unregister("minPrice"); // custom register minPrice input
            unregister("maxPrice");
        }
    }, [register, unregister])

    const handleChangePrice = useCallback((valores) => {
        setValue('minPrice', valores.minPrice)
        setValue('maxPrice', valores.maxPrice)
        handleChangeFilterPrice(valores)
    }, [setValue, handleChangeFilterPrice])

    const classMain = classNames(
        'c23FilterMain',
        { 'c23FilterMainHide': !showFilter },
    )

    useEffect(() => {
        if (widthWindow > 960) {
            setShowFilter(true)

        } else if (widthWindow <= 960) {
            setShowFilter(false)
        }
    }, [widthWindow, setShowFilter])

    // async function getComuna(selected) {
    //     // console.log("dataComuna********************************", selected.target.value, selected.value)
    //     let url_servicio_web = localStorage.getItem('url_servicio_web')
    //     const configGetComuna = {
    //         method: 'POST',
    //         url: url_servicio_web + "get_Comuna?fi_Region=" + selected.target.value,

    //     };
    //     let response = await axios(configGetComuna)
    //     let Comunas = []
    //     console.log("response- configGetComuna------------------------->", response);
    //     response.data.forEach(element => {
    //         Comunas.push({ value: element.fi_COMUNA, label: element.fc_DESCRIPCION, fc_TIPO_DISPONIBILIDAD: element.fc_TIPO_DISPONIBILIDAD })
    //     });
    //     setDataComunas(Comunas)
    // }
    let id_familia = localStorage.getItem('id_familia')
    const [itemEvent, setItemEvent] = useState(null);
    const InputCheckSelectData = dataFilterTypes.filter(filtro => !filtro.Descripcion.includes("MB") && !filtro.Descripcion.includes("GB")).map((item, index) => (
        <InputSelect
            key={uuid()}
            type={id_familia === "SHO" && id_familia !== undefined ? InputSelectType.RADIO : InputSelectType.CHECKBOX}
            text={item.Descripcion}
            name={item.id}
            className='c23FilterCheckbox'
            onChange={e => { getPlanesByCheckBox(e, item, null, canalContext?.context);  setItemEvent({e, item})}}
            checked={item.checked}
        />
    ))
    const InputCheckSelectDataChilds = dataFilterTypesChilds?.length ? dataFilterTypesChilds.map((item, index) => (
        <InputSelect
            key={uuid()}
            type={InputSelectType.CHECKBOX}
            text={item.fc_DESCRIPCION}
            name={item.fi_OPCION_FILTRO}
            className='c23FilterCheckbox'
            onChange={e => { getPlanesByCheckBoxChilds(e, item) }}
            checked={item.checked}
        // disabled={item.disabled}
        />
    )) : null

    const InputCheckSelectDataHead = []/* dataFilterTypesHead.map((item, index) => (
        <InputSelect
            key={uuid()}
            type={InputSelectType.RADIO}
            // register={register("typePlay[0]", {required: false})} 
            text={item.Descripcion}
            name={item.id}
            className=''
            onChange={e => { getPlanesByCheckBoxHead(e, item) }}
            checked={item.checked}
            disabled={item.disabled}
        // defaultValue='1Play'
        // checked={true}
        />
    ))*/

    const checkedSelectedVelocity  = (e, velocity) => {
        setVelocidadInternet(currentValue => {
            const index = currentValue.map(velocidad => velocidad.valor).indexOf(velocity)
            console.log(index, e, "pruebasssssshola", currentValue, velocity)
            currentValue[index].checked = e.target.checked;
           
            setCounterVelocityFilters(velocidadesInternet.filter(velocidad => velocidad.checked).length)
            

            console.log(velocity, currentValue,"lavelocidaddd")
            return [...currentValue];
        })

    };

useEffect(() => {
    console.log(velocidadesInternet,"lasvelocidadesinternet")
}, [velocidadesInternet])

    useEffect(() => {
        let velocidadesInternetSecundaria = [];
        dataCPlanesBk.forEach(plan => {
            plan.caracteristicas.forEach(caracteristica => {
                let caracteristicaValor = caracteristica.fc_VALOR?.trim();
                if(caracteristicaValor == "") {
                    return;
                }

                if(caracteristicaValor?.includes("/")) {
                    const text = caracteristicaValor;
                    const regex = /\b\d{1,8}\s?MB\b/;
                    const match = text.match(regex);

                    if (match) {
                        console.log(match[0], "aquihh");  // Output: 50MB
                        caracteristicaValor = match[0].trim()
                    }

                }

                

                if((caracteristica.fc_TITULO === "Wi-Fi" || caracteristica.fc_TITULO === "Velocidad") && !velocidadesInternetSecundaria.some(velocidad => { console.log(velocidad.valor.toLowerCase(), caracteristicaValor.toLowerCase(), "prueaasdk"); return velocidad.valor.toLowerCase() === caracteristicaValor.toLowerCase()})) {
                    
                    velocidadesInternetSecundaria.push({valor: caracteristicaValor, checked: false});
                }
            });
        });

        console.log(velocidadesInternetSecundaria, "velocidadesInternetSecundaria")
        setVelocidadInternet(velocidadesInternetSecundaria)
    }, [dataCPlanesBk])
    
    const [cond, setCond] = useState(false )
  

    const nameChannels =[
            "wapa tv",
            "telemundo",
            
        
            "teleonce",
            
        
            "abc pr",
            
        
            "cbs",
            
        
            "fox pr",
            
        
            "nbc",
            
        
            "espn",
            
        
            "animal planet",
            
        
            "disney channel",
            
        
            "food network",
            
        
            "discovery kids la",
            
    ]

    useEffect(() => {
        let getChanels = dataChannelsBk.filter(channel => nameChannels.includes(channel.fc_nombre.toLowerCase().trim()))
        let channelObjects = getChanels.map(channel => ({name: channel.fc_nombre, checked: false, canal: channel.fi_canal, lstOpcionFiltros: channel.lstOpcionFiltros}))
        console.log(channelObjects, "estooooos")
        setCheckboxes(channelObjects)
    }, [dataChannelsBk])

    
console.log("hlaskdfjaskl")
    return (
        <div className={classMain}>
            <form
                className='c23Filter'
                onSubmit={handleSubmit(onSubmit)}
            >
                {/* Solo se muestra este campo en responsive */}
                <div className='c23FilterBlock c23FilterBlockTop'>
                    {/* <p>
                        Valores de todo el formulario de filtro:
                        { JSON.stringify( getValues())}
                    </p> */}
                    <Title
                        tag={TitleTag.H2}
                        style={TitleStyle.H4}
                        className=''
                    >
                        Filtrar por
                    </Title>
                    <i className='ico-x' onClick={() => { setShowFilter(!showFilter) }}></i>
                </div>
                {
                    InputCheckSelectDataHead?.length > 1
                        ?
                        <div className='c23FilterBlock'>
                            <div className={`c23FilterBlockItems c23FilterBlockItemsShow c23FilterBlockItemsPlay`}>
                                <SimpleBar
                                    style={{ maxHeight: "200px" }}
                                >
                                    <div className='c23FilterBlockPlay'>
                                        {
                                            InputCheckSelectDataHead
                                        }
                                    </div>

                                </SimpleBar>
                            </div>
                        </div>
                        : null
                }
                <div className='c23FilterClear'>
                    <span>{counterFilters} filtros seleccionados</span>
                    {/* <span className='c23FilterClearAct' onClick={(e) => { clearFilters(e, true); setDataComunas([]) }}>Limpiar filtros</span> */}
                    <span className='c23FilterClearAct' onClick={(e) => {setItemEvent(null); setCanalContext({canal: null, context: null}); clearFilters(e, true); setVelocidadInternet(currentValue => currentValue.map(velocidad => {velocidad.checked = false; return velocidad}))}}>Limpiar filtros</span>

                </div>
                
                {InputCheckSelectData.length > 0 && <div className='c23FilterBlock'>

                    <div className='c23FilterSubtitle'>
                        <p>
                            Tipo de plan
                        </p>

                    </div>
                    <div className={`c23FilterBlockItems c23FilterBlockItemsShow typePlanScroll`}>
                        <SimpleBar
                            style={{ maxHeight: "300px" }}
                        >
                            {
                                InputCheckSelectData
                            }
                        </SimpleBar>
                        {/* <InputSelect
                            type={InputSelectType.CHECKBOX}
                            register={register("typePlan[0]", { required: false })}
                            text='2 Play: Internet + Televisión'
                            name='typePlan[0]'
                            defaultValue='2 Play: Internet + Televisión'
                            className='c23FilterCheckbox'
                        /> */}

                    </div>

                </div>}

                

                <C23Filtercollapse itemEvent={itemEvent}
        getPlanesByCheckBox={getPlanesByCheckBox} filterPlansByInternetVelocity={filterPlansByInternetVelocity} velocidadesInternet={velocidadesInternet}
        checkedSelectedVelocity={checkedSelectedVelocity} cond={cond} setCond={setCond} canalContext={canalContext}/>


{localStorage.getItem("url_detalle_default") != "" && <C23Filtercollapse2 init={false} render={(cond, setCond)=>(
                        <>
                            {/* <div className='c23FilterBlock'> */}
                            <div className='c23FilterSubtitle' onClick={()=>setCond(c=>!c)}>
                                <p>
                                    Canales
                                </p>
                                <i className={`${cond ? 'ico-chevron-down': 'ico-chevron-up'}`}></i>
                            </div>
                            <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                                <SimpleBar
                                    style={{ maxHeight: "200px" }}
                                >
                                {checkboxes.map(caja => {
                                    return <InputSelect
                                        type={InputSelectType.CHECKBOX}
                                        register={register(caja.name, { required: false })}
                                        text={caja.name}
                                        name={caja.name}
                                        defaultValue={caja.name}
                                        className='c23FilterCheckbox'
                                        checked={caja.checked}
                                        onClick={() => {
                                            let newCheckboxes = [...checkboxes]
                                            let entro = false;
                                            let entroValue = false;
                                            newCheckboxes.forEach(channel => {
                                                if(caja.canal == channel.canal) {
                                                    channel.checked = !channel.checked;

                                                    entro = true;
                                                    entroValue = channel.checked;
                                                }
                                            });

                                            function setCounterChannel() {
                                                if(entro) {
                                                    if(entroValue) {
                                                        setCounterChannelFilters(cv => cv + 1)
                                                    }
    
                                                    if(!entroValue) {
                                                        setCounterChannelFilters(cv => {
                                                            if(cv > 0) {
                                                                cv -= 1;
                                                            }
    
                                                            return cv;
                                                        })
                                                    }
                                                }
                                            }

                                            setCheckboxes(newCheckboxes)
                                            setCanalContext({canal: caja.canal, context: newCheckboxes})

                                            console.log(newCheckboxes, "checkboxesppp");

                                            if(itemEvent){
                                                getPlanesByCheckBox(itemEvent.e, itemEvent.item, caja?.canal, newCheckboxes, null, setCounterChannel)
                                            }else{
                                                filterPlansByInternetVelocity(null, null, caja?.canal, newCheckboxes, setCounterChannel)
                                            }
                                        }}
                                    />
                                })}
                                    
                                </SimpleBar>
                            </div>
                                    
                            {/* </div> */}
                        </>
                    )}/>}
                {
                    InputCheckSelectDataChilds
                        ?
                        <div className='c23FilterBlock'>

                            <div className='c23FilterSubtitle'>
                                <p>
                                    Opciones
                                </p>
                            </div>
                            <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                                <SimpleBar
                                    style={{ maxHeight: "200px" }}
                                >
                                    {
                                        InputCheckSelectDataChilds
                                    }
                                </SimpleBar>
                            </div>
                        </div>
                        :
                        null
                }
                {false && <div className='c23FilterBlock c23FilterBlockBottom'>
                    <div className="c23FilterSubtitle">
                        <p>
                            Precio
                        </p>
                    </div>

                    <div className='c23FilterRangeBar'>
                        {/* <ProgressBar percentage={60}/> */}
                        <RangeSlider
                            min={rangePrice.min}
                            max={rangePrice.max}
                            onChange={v => handleChangePrice(v)}
                        />
                    </div>

                </div>}
                {/* <div className='c23FilterBlock c23FilterBlockBottom'>
                    <div className="c23FilterSubtitle">
                        <p>Ubicación</p>
                    </div>

                    <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                        <div className="c23FilterSelect">
                            <span> Región </span>
                            <span className="select">
                                <select defaultValue='' onChange={(selected) => getComuna(selected)}>
                                    <option value="" disabled>Selecciona una región</option>
                                    {optionsRegiones}
                                </select>
                            </span>
                        </div>
                        <div className="c23FilterSelect">
                            <span> Zona </span>
                            <span className="select">
                                <select defaultValue='-1' onChange={(selected) => getPlanesByComuna(selected)}>
                                    <option value="-1" disabled>Selecciona una zona</option>
                                    {dataComunas.map(item => (
                                        <option key={item.value} value={item.value + "_" + item.fc_TIPO_DISPONIBILIDAD}>{item.label}</option>
                                    ))}

                                </select>
                            </span>
                        </div>
                    </div>
                </div> */}

            </form>
        </div>
    )
})

ServiceFilter.propTypes = {
    onSubmit: PropTypes.func,
    showFilter: PropTypes.bool,
    setShowFilter: PropTypes.func,
}
ServiceFilter.defaultProps = {
    onSubmit: () => { },
    showFilter: true,
    setShowFilter: () => { }
}


function C23OneCardForMonths(props) {
    console.log("v6 opcion")
    const{
        dataChannelsBk,
        dataCategorias,
    }= props
    // let history = useHistory();
    const [canalContext, setCanalContext] = useState(null);
    const [dataCPlanes, setdataCPlanes] = useState([])
    const [dataCPlanesBk, setdataCPlanesBk] = useState([])
    const [dataCPlanesBkHead, setdataCPlanesBkHead] = useState([])
    const [dataRegiones, setDataRegiones] = useState([])
    const [dataFilterTypes, setDataFilterTypes] = useState([])
    const [dataFilterTypesChilds, setDataFilterTypesChilds] = useState([])
    const [dataFilterTypesBK, setDataFilterTypesBk] = useState([])
    const [dataFilterTypesHead, setDataFilterTypesHead] = useState([])
    // const [dataFilterOptions, setDataFilterOptions] = useState([])
    const [inputSearch, setinputSearch] = useState('')
    const [optionFilter, setOptionFilter] = useState('')
    const [optiondHigherLower, setOptiondHigherLower] = useState('')
    const [filterComuna, setFilterComuna] = useState('')
    const [rangePriceState, setRangePriceState] = useState({ min: 0, max: 400 })
    const [showFilter, setShowFilter] = useState(true)
    const [offset, setOffset] = useState(0)
    const [pageCount, setPageCount] = useState(1)
    const [perPage, setPerPage] = useState(6)
    const [dataToItems, setDataToItems] = useState([])
    const [counterFilters, setCounterFilters] = useState(0)
    const [counterVelocityFilters, setCounterVelocityFilters] = useState(0)
    const [counterChannelFilters, setCounterChannelFilters] = useState(0)
    const [counterFiltersHead, setCounterFiltersHead] = useState(0)
    const [preFilterRemove, setPreFilterRemove] = useState(true)
    const [preFilterRealizo, setPreFilterRealizo] = useState(false)
    const [preFiltros] = useState(localStorage.getItem("id_filtro_planes") ? localStorage.getItem("id_filtro_planes") : 0)
    // const [velocidadesInternet, setVelocidadInternet] = useState([]);

    const [keysPlanCompare, setKeysPlanCompare] = useState([])
    const [regresaPlanes, setRegresaPlanes] = useState(false)

    async function getMinMaxPrice(dataArray = null) {
        // console.log("Calculate range price min and max***********", dataArray)
        if (!dataArray?.length) {
            // console.log("Calculate range price min and max if ***********", dataArray)
            // return { min: 0, max: 20000 }
            await setRangePriceState({ min: 0, max: 20000 })
        } else {
            // console.log("Calculate range price min and max else***********", dataArray)
            dataArray.sort(function (a, b) {
                return a.fi_PRECIO_PLAN - b.fi_PRECIO_PLAN
            })
            let min = dataArray[0].fi_PRECIO_PLAN;
            let max = dataArray[dataArray.length - 1].fi_PRECIO_PLAN;
            // console.log("Calculate range price min and max___________________________________", min, max)
            await setRangePriceState({ min: min, max: max })
        }
    }

    async function getCPlanes() {
        // console.log("dataCPlanes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let id_familia = localStorage.getItem('id_familia')
        let id_filtro = localStorage.getItem('id_filtro_planes') ? localStorage.getItem('id_filtro_planes') : '0'
        const configCPlanes = {
            method: 'GET',
            url: url_servicio_web + "get_cplanes?fi_familia=" + id_familia + "&fi_filtro=" + id_filtro,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configCPlanes)
        console.log("response- getCPlanes------------------------->", response,dataFilterTypes);
        let pageCountVal = response.data ? (Math.ceil(response.data.length / perPage)) : 1;
        let planesFilter = dataFilterTypes.length ? response.data.filter(p => {
                
            return p.lstFiltrosxPlan?.find( l => dataFilterTypes.find(f => l.fi_OPCION_FILTRO === f.id))
        }) : response.data
        //console.log("planesfilter",planesFilter)
        
        setdataCPlanes(planesFilter)
        await setdataCPlanesBk(planesFilter)
        await setdataCPlanesBkHead(planesFilter)
        getMinMaxPrice(planesFilter)

        setPageCount(pageCountVal)
        setPerPage(6)

    }

    

    async function getRegiones() {
        // console.log("getRegiones********************************+")
        // let url_servicio_web = localStorage.getItem('url_servicio_web')
        // const configRegiones = {
        //     method: 'GET',
        //     url: url_servicio_web + "get_Region",

        // };
        // let response = await axios(configRegiones)
        let Regiones = []
        // console.log("response- getRegiones------------------------->", response);
        // response.data.forEach(element => {
        //     Regiones.push({ value: element.fi_REGION, label: element.fc_DESCRIPCION })
        // });
        setDataRegiones(Regiones)
    }

    async function getFilterTypes() {
        // console.log("getFilterTypes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fc_familia = localStorage.getItem('id_familia')
        const configRegiones = {
            method: 'GET',
            url: url_servicio_web + "get_FilterTypes?fc_familia=" + fc_familia + "&fi_tipo_filtro=1",
        };
        let response = await axios(configRegiones)
        let FilterTypes = [] //, elements = {}
        // console.log("response- getFilterTypes------------------------->", response);

        response.data.forEach(dfilt => {
            FilterTypes.push({ id: dfilt.fi_OPCION_FILTRO, fi_FILTRO: dfilt?.fi_FILTRO, Descripcion: dfilt.fc_DESCRIPCION, checked: false, lstTipoFiltro: dfilt.lstTipoFiltro, disabled: false })
        });
        // console.log("setDataFilterTypes", FilterTypes)
        let filtrosPre = preFiltros > 0 ? FilterTypes.filter(f => f.fi_FILTRO.toString() === preFiltros) : FilterTypes
        setDataFilterTypes(filtrosPre)
        setDataFilterTypesBk(filtrosPre)
    }

    async function getFilterTypesHead() {
        // console.log("getFilterTypes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fc_familia = localStorage.getItem('id_familia')
        const configRegiones = {
            method: 'GET',
            url: url_servicio_web + "get_HeadFilterTypes?fc_familia=" + fc_familia,
        };
        let response = await axios(configRegiones)
        let FilterTypesHead = [] //, elements = {}
        // console.log("response- getFilterTypesHead------------------------->", response);

        response.data.forEach(dfilt => {
            FilterTypesHead.push({ id: dfilt.fi_FILTRO, Descripcion: dfilt.fc_DESCRIPCION, checked: false, disabled: false })
        });
        // console.log("setDataFilterTypes", FilterTypes)
        setDataFilterTypesHead(FilterTypesHead)
    }

    /*async function getFilterOptions() {
        // console.log("getFilterOptions********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fc_familia = localStorage.getItem('id_familia')
        const configRegiones = {
            method: 'GET',
            url: url_servicio_web + "get_FilterOptions?fc_familia=" + fc_familia,

        };
        let response = await axios(configRegiones)
        let FilterOptions = [] //, elements = {}
        console.log("response- getFilterOptions------------------------->", response);

        response.data.forEach(dfilt => {
            FilterOptions.push({ value: dfilt.fi_OPCION_FILTRO, label: dfilt.fc_DESCRIPCION })
        });
        setDataFilterOptions(FilterOptions)
        console.log("setDataFilterOptions", dataFilterOptions)
    }*/

    const handleChangeFilterPrice = (el) => {
        const result = Object.values(el);
        console.log("handleChangeFilterPrice.......", result);
        setRangePriceState({ min: result[0], max: result[1] })
        getFilterPlansByPrices(result[0], result[1])

    }
    const getPlanesByCheckBoxChilds = (el, item) => {
        let isCheck = el.target.checked
        let idFiltro = parseInt(el.target.name)
        let newArrayChecks = dataFilterTypesChilds.map((filt, index) => {
            if (filt.fi_OPCION_FILTRO === item.fi_OPCION_FILTRO) {
                filt.checked = isCheck
            }
            return filt;
        })
        setDataFilterTypesChilds(newArrayChecks)
        console.log("getPlanesByCheckBoxChilds isCheck: from lstFiltrosxPlan ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypes, newArrayChecks);
        getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
    }

    const getPlanesByCheckBox = (el, item, canal = null, setCheckboxes = null, velocidad = null, setCurrentChannel = () => {}) => {
        setResetPage(currentValue => !currentValue)
        let isCheck = el.target.checked
        item.check = isCheck
        let idFiltro = parseInt(el.target.name)
        let lstFiltrosxPlan = item.lstTipoFiltro
        let id_familia = localStorage.getItem("id_familia")
        console.log("getPlanesByCheckBox----------------------------- id_familia:", id_familia, " lstTipoFiltro:", item.lstTipoFiltro)

        let newArrayChecks = dataFilterTypes.map((filt, index) => {
            if (lstFiltrosxPlan?.length && isCheck) {
                filt.disabled = true
            } else {
                filt.disabled = false
            }

            if (filt.id === item.id) {
                filt.checked = isCheck
                filt.disabled = false
            }

            return filt;
        })

        if (lstFiltrosxPlan?.length && isCheck) {
            newArrayChecks = dataFilterTypes.map((filt, index) => {
                if (filt.id === item.id) {
                    filt.checked = isCheck
                    filt.disabled = false
                } else {
                    filt.checked = false
                    filt.disabled = true
                }

                return filt;
            })
            setDataFilterTypesChilds(lstFiltrosxPlan)
        } else {
            console.log("holazzzzzz")

            let newArrayChecksChilds = dataFilterTypesChilds.map((filt, index) => {
                filt.checked = false
                return filt;
            })

            setDataFilterTypesChilds(newArrayChecksChilds)
            //if (isCheck) {
                if (id_familia === "SHO") {
                    newArrayChecks = dataFilterTypes.map((filt, index) => {
                        if (filt.id === item.id) {
                            filt.checked = isCheck
                            filt.disabled = false
                        } else {
                            filt.checked = false
                            filt.disabled = true
                        }
                        return filt;
                    })
                }
                setDataFilterTypes(newArrayChecks)
                console.log("getPlanesByCheckBox setCheckboxes: ", setCheckboxes, "idFiltro: " + idFiltro, item, dataFilterTypes, newArrayChecks, "lstFiltrosxPlan", lstFiltrosxPlan?.length, lstFiltrosxPlan);
                getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch, null, canal, setCheckboxes, velocidad)
            //}
            setDataFilterTypesChilds([])
        }

        setCurrentChannel()
        // setDataFilterTypes(newArrayChecks)
        // console.log("getPlanesByCheckBox isCheck: ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypes, newArrayChecks, "lstFiltrosxPlan", lstFiltrosxPlan?.length, lstFiltrosxPlan);
        // getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
    }

    const getPlanesByCheckBoxHead = (el, item) => {
        let isCheck = el.target.checked
        let idFiltro = parseInt(el.target.name)

        let newArrayChecks = dataFilterTypesHead.map((filt, index) => {
            if (filt.id === item.id) {
                filt.checked = isCheck
            } else {
                // filt.disabled = isCheck
                filt.checked = !isCheck
            }
            return filt;
        })
        setDataFilterTypesHead(newArrayChecks)
        console.log("getPlanesByCheckBoxHead isCheck: ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypesHead, newArrayChecks);
        // getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
        if (isCheck) {
            getDataFilterTypes(item.id)
        } else {
            getDataFilterTypes()
        }
    }

    const getDataFilterTypes = (idFiltro = null) => {
        let newArrayChecks = []
        if (idFiltro !== null) {
            clearFilters(null, false)
            newArrayChecks = dataFilterTypesBK.filter(filt => filt.fi_FILTRO === idFiltro);
            getFilterPlansByPlay(newArrayChecks)
            setCounterFiltersHead(1)
        } else {
            newArrayChecks = dataFilterTypesBK
            clearFilters(null, true)
            setCounterFiltersHead(0)
        }
        setDataFilterTypes(newArrayChecks)
        console.log("getDataFilterTypes isCheck: ", "idFiltro: " + idFiltro, dataFilterTypes, newArrayChecks);

    }

    const getPlanesByComuna = (el) => {
        console.log("getPlanesByComuna---------------------", el, el.target.value);
        let valComuna = el.target.value.split("_")[1]
        setFilterComuna(valComuna)
        getFilterPlansByComuna(valComuna)
    }

    // const onChangeFilterOptions = (el) => {

    //     let val = el.target.value
    //     setOptionFilter(val)
    //     getFilterPlanesByOptions(val)
    //     console.log("onChangeFilterOptions---------------------", val);
    // }

    const handleChangeCompare = (el) => {
        let isCheck = el.target.checked
        let planId = parseInt(el.target.name)
        console.log("handleChangeCompare isCheck: " + isCheck, "planId:" + planId);
        if (isCheck) {
            const exist = keysPlanCompare.filter((id) => id === planId);
            if (!exist.length) {
                setKeysPlanCompare([...keysPlanCompare, planId])
            }
        } else {
            let newarray = keysPlanCompare.filter(element => element !== planId);
            setKeysPlanCompare(newarray)
        }
    }

    const resetHandleClick = (el) => {

        console.log("resetHandleClick: " + el);
        setKeysPlanCompare([])
        setDataToItems([])
    }
    function clearFilters(e, clearHead = true) {
        console.log("clearFilters: ", e);
        setinputSearch('')
        setOptionFilter('')
        setFilterComuna('')
        // setDataFilterOptions([])
        setOptionFilter('')
        setCounterFilters(0)
        setCounterFiltersHead(0)

        setdataCPlanes(dataCPlanesBkHead)
        setdataCPlanesBk(dataCPlanesBkHead)

        let newArrayChecksChilds = dataFilterTypesChilds?.length ? dataFilterTypesChilds.map((filt, index) => {
            filt.checked = false
            return filt;
        }) : []
        setDataFilterTypesChilds(newArrayChecksChilds)
        setDataFilterTypesChilds([])
        let pageCountVal = dataCPlanesBkHead.length ? (Math.ceil(dataCPlanesBkHead.length / perPage)) : 1;
        setOffset(0)
        setPageCount(pageCountVal)
        let newArrayChecks = dataFilterTypes.map((filt, index) => {
            if (filt.id) {
                filt.checked = false
                filt.disabled = false
            }
            return filt;
        })
        setDataFilterTypes(newArrayChecks)
        if (clearHead) {
            let newArrayChecksHead = dataFilterTypesHead.map((filt, index) => {
                if (filt.id) {
                    filt.checked = false
                    filt.disabled = false
                }
                return filt;
            })
            setDataFilterTypesHead(newArrayChecksHead)
        }
        console.log("clearFilters: end: ", e);
        const nameChannels =[
            "wapa tv",
            "telemundo",
            
        
            "teleonce",
            
        
            "abc pr",
            
        
            "cbs",
            
        
            "fox pr",
            
        
            "nbc",
            
        
            "espn",
            
        
            "animal planet",
            
        
            "disney channel",
            
        
            "food network",
            
        
            "discovery kids la",
            
    ]
        let getChanels = dataChannelsBk.filter(channel => nameChannels.includes(channel.fc_nombre.toLowerCase().trim()))
        let channelObjects = getChanels.map(channel => ({name: channel.fc_nombre, checked: false, canal: channel.fi_canal, lstOpcionFiltros: channel.lstOpcionFiltros}))
        console.log(channelObjects, "estooooos")
        // setCheckboxes([])
        setCheckboxes([...channelObjects])
        setCounterVelocityFilters(0)
        setCounterChannelFilters(0)
    }

    function removeItemHandleClick(el) {
        // let idPlanRemove = parseInt(el.target.id)
        console.log("removiendo", el)
        let idPlanRemove = parseInt(el.fi_PLAN)
        if (idPlanRemove) {
            let newarray = keysPlanCompare.filter(element => element !== idPlanRemove);
            // setKeysPlanCompare(newarray)
            // console.log("removeItemHandleClick: " + el.target, "id: " + el.target.id, "name: " + el.target.name, idPlanRemove, newarray);
            setKeysPlanCompare(newarray)
            let dataToItems = dataCPlanesBk.filter(f => newarray.includes(f.fi_PLAN));
            let arrayItemes = { items: dataToItems }
            console.log("dataToItems::::::::::::::::::::" + dataToItems, arrayItemes, keysPlanCompare.length);
            setDataToItems(arrayItemes)
        }
        // setDataToItems([])
    }

    function onChangeInputSearch(e) {
        console.log("onChangeInputSearch", e.target.value)
        let textValue = e.target.value
        if (textValue.length) {
            setinputSearch(textValue)

        } else {
            let list = dataCPlanesBk
            list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)
            setdataCPlanes(list)
            let pageCountVal = list.length ? (Math.ceil(list.length / perPage)) : 1;
            setOffset(0)
            setPageCount(pageCountVal)
        }
    }

    function getFilterPlansByPrices(min, max) {
        console.log("function getFilterPlansByPrices***********", min, max)
        let r = { min: min, max: max }
        getFilterPlansMulti(r, dataFilterTypes, filterComuna, optionFilter, inputSearch)
        // let data = dataCPlanes.length ? dataCPlanes : [];

        // let newDataFilter = data.filter((plan, index) => {
        //     // console.log("getFilterPlans... filter:", index, min, max, plan.fi_PRECIO_PLAN)
        //     // console.log("getFilterPlans... filter:", index, min + " es mayor " + mayor, max + " es menor " + menor, plan.fi_PRECIO_PLAN)
        //     return ((plan.fi_PRECIO_PLAN >= min) === true && (plan.fi_PRECIO_PLAN <= max) === true);
        // });
        // console.log("getFilterPlansByPrices....------", newDataFilter)
        // let list = newDataFilter
        // list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)

        // let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        // setdataCPlanes(list)
        // // getMinMaxPrice()
        // // handlePageClick({selected: 0})
        // setPageCount(pageCountVal)
        // setOffset(0)
        // console.log("to search---------- getFilterPlansByPrices:", pageCountVal, newDataFilter, newDataFilter.length)
    }

    function getFilterPlansByComuna(fc_TIPO_DISPONIBILIDAD) {
        console.log("getFilterPlansByComuna***********", fc_TIPO_DISPONIBILIDAD)
        getFilterPlansMulti(rangePriceState, dataFilterTypes, fc_TIPO_DISPONIBILIDAD, optionFilter, inputSearch)
        // let data = dataCPlanes.length ? dataCPlanes : [];

        // let newDataFilter = data.filter((plan, index) => {
        //     return plan.fc_TIPO_DISPONIBILIDAD === fc_TIPO_DISPONIBILIDAD;
        // });
        // console.log("getFilterPlansByComuna....------", newDataFilter)
        // let list = newDataFilter
        // list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)

        // let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        // setdataCPlanes(list)
        // setPageCount(pageCountVal)
        // setOffset(0)
        // console.log("---------- getFilterPlansByComuna:", pageCountVal, newDataFilter, newDataFilter.length)
    }

    // function getFilterPlanesByOptions(idOpcionFiltro) {
    //     getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, idOpcionFiltro, inputSearch)
    // }

    function getFilterPlansByPlay(dataFilterTypesData) {
        let data = dataCPlanesBkHead?.length ? dataCPlanesBkHead : []
        let newDataFilter = data.filter((data, index) => {
            let flagCheck = -1;
            let arraykeyCheck = []
            let CheckedsBox = dataFilterTypesData.map((filt, index) => {
                if (filt.id) {
                    arraykeyCheck.push(filt.id)
                }
                return filt
            })

            let isExist = false
            let result = data.lstFiltrosxPlan.map(option => {
                let isSameId = arraykeyCheck.includes(option.fi_OPCION_FILTRO)
                if (isSameId) isExist = true
                return isExist
            })
            if (isExist) {
                flagCheck = 1
            }

            // console.log("check if getFilterPlansByPlay*********** CheckedsBox: isExist", isExist, CheckedsBox, result)
            if (flagCheck > -1) {
                console.log("FLAGS-------------", flagCheck, data, arraykeyCheck, result, CheckedsBox)
                return data
            } else {
                return null
            }
        })
        let list = newDataFilter

        list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)
        console.log("to search---------- getFilterPlansByPlay:", dataCPlanesBkHead, newDataFilter, newDataFilter.length)
        let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(list)
        setdataCPlanesBk(list)
        // getMinMaxPrice()
        setOffset(0)
    }
    function getFilterPlansMulti(price = null, check = null, comuna = null, option = null, input = null, OrdHigherLower = null, canal = null, setCheckboxes = null, velocidad = null) {
        console.log("function getFilterPlansMulti*********** Init::::", setCheckboxes, "price: ", price, "check: " + check, "comuna: " + comuna, "option: " + option, "input: " + input)
        // if (inputSearch.length) {
        let data = dataCPlanesBk.length ? dataCPlanesBk : [];
        let ContaFilter = []

        let newDataFilter = data.filter((data, index) => {
            let flagInput = -1, flagComuna = -1, flagOption = -1, flagCheck = -1;

            if (input.length) {
                console.log("input if getFilterPlansMulti***********", "input: " + input)
                ContaFilter[0] = true
                for (let [key, value] of Object.entries(data)) {

                    if (key === "caracteristicas" && value.length) {
                        for (let [keyC, valueC] of Object.entries(value)) {
                            // let valueCS = String(value)

                            if (valueC.fc_TITULO.toLowerCase().search(inputSearch.toLowerCase()) > -1 || valueC.fc_VALOR.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                                console.log("------------------caracteristicas index:" + index, keyC, valueC.fc_TITULO.toLowerCase(), valueC.fc_VALOR.toLowerCase(), inputSearch.toLowerCase());
                                flagInput = index
                            }
                        }
                    } else {
                        let valueS = String(value)
                        // console.log("------------------ index:"+index, valueS.toLowerCase(), inputSearch.toLowerCase());
                        if (valueS.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                            console.log("------------------ index:" + index, key, valueS.toLowerCase());
                            flagInput = index
                        }
                    }
                }
            }
            if (comuna) {
                let dcomuna = data.fc_TIPO_DISPONIBILIDAD === comuna;
                ContaFilter[1] = true
                if (dcomuna) {
                    flagComuna = 1
                }
                console.log("comuna if getFilterPlansMulti***********", "comuna: " + comuna, flagComuna)
            }
            if (option) {
                let doption = data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === parseInt(option)))
                ContaFilter[2] = true
                if (doption !== undefined) {
                    flagOption = doption.fi_OPCION_FILTRO
                }
                console.log("option if getFilterPlansMulti***********", "option: " + parseInt(option), flagOption)
            }
            if (check) {

                // let dcheck = data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === parseInt(check)))
                // ContaFilter[4] = true
                // if (dcheck !== undefined) {
                //     flagCheck = dcheck.fi_OPCION_FILTRO
                // }
                // let getByChecked = dataFilterTypes.map((filt, index) => {
                //     if (filt.checked) {
                //         console.log("check if getFilterPlansMulti*********** check:", filt)
                //         return data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === filt.id))
                //     } else {
                //         return null;
                //     }
                // })

                let arraykeyCheck = []
                let keysConta = 3
                let CheckedsBox = dataFilterTypes.map((filt, index) => {
                    if (filt.checked) {
                        keysConta += index
                        arraykeyCheck.push(filt.id)
                        ContaFilter[keysConta] = true
                    }
                    return filt
                })

                let isExist = false
                let result = data.lstFiltrosxPlan.map(option => {
                    let isSameId = arraykeyCheck.includes(option.fi_OPCION_FILTRO)
                    if (isSameId) isExist = true
                    return isExist
                })
                if (isExist) {
                    flagCheck = 1
                } else if(!arraykeyCheck.length){
                    flagCheck = 1
                }

                console.log("check if getFilterPlansMulti*********** CheckedsBox: isExist", isExist, CheckedsBox, result)
            }

            if (flagInput > -1 || flagComuna > -1 || flagOption !== -1 || flagCheck > -1) {
                console.log("FLAGS-------------", flagInput, flagComuna, flagOption, flagCheck, data)
                return data
            } else {
                console.log("FLAGS ELSE-------------", flagInput, flagComuna, flagOption, flagCheck)
                return null
            }
        });
        let dataNew = newDataFilter
        console.log("FLAGS newDataFilter-------------", dataNew)
        let newDataFilterPrices = dataNew.filter((data, index) => {
            let flagPrices = -1
            if (price) {
                let dprice = ((data.fi_PRECIO_PLAN >= price.min) === true && (data.fi_PRECIO_PLAN <= price.max) === true);
                // ContaFilter[3] = true
                if (dprice) {
                    flagPrices = 1
                }
                console.log("function getFilterPlansMulti*********** price: ", price, dprice)
            }
            if (flagPrices > -1) {
                return data
            } else {
                return null
            }
        })
        let counter = 0
        ContaFilter.map((item, index) => (
            counter++
        ))

        setCounterFilters(counter)
        let list = newDataFilterPrices
        let list2 = newDataFilterPrices
        list.sort((a, b) => (a.fi_PRECIO_PLAN > b.fi_PRECIO_PLAN) ? 1 : -1)
        if (OrdHigherLower !== null) {
            console.log("OrdHigherLower !null ", OrdHigherLower)
            if (OrdHigherLower === "1") {
                list2.sort((a, b) => (a.fi_PRECIO_PLAN > b.fi_PRECIO_PLAN) ? 1 : -1)
                console.log("OrdHigherLower >", OrdHigherLower)
            }
            if (OrdHigherLower === "2") {
                list2.sort((a, b) => (a.fi_PRECIO_PLAN < b.fi_PRECIO_PLAN) ? 1 : -1)
                console.log("OrdHigherLower <", OrdHigherLower)
            }
            console.log("to OrdHigherLower----------:", list2)
            list = list2
        }

        let pageCountVal = newDataFilterPrices.length ? (Math.ceil(newDataFilterPrices.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(list)
        filterPlansByInternetVelocity(velocidad, list, canal, setCheckboxes)

        // getMinMaxPrice()
        setOffset(0)
        console.log("to search---------- getFilterPlans:", pageCount, pageCountVal, perPage, newDataFilterPrices, newDataFilterPrices.length)
        // }
    }

    function onHandleClickSearch(e) {
        getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
    }

    function routeChange(e) {
        console.log("routeChange__________***********", inputSearch, dataCPlanesBk,)
        let dataToItems = dataCPlanesBk.filter(f => keysPlanCompare.includes(f.fi_PLAN));
        let arrayItemes = { items: dataToItems }
        console.log("dataToItems::::::::::::::::::::", dataToItems, arrayItemes, keysPlanCompare.length);
        setRegresaPlanes(false)
        setDataToItems(arrayItemes)
        // history.push({ pathname: path, state: { data: { items: dataToItems }, plansToCompare: keysPlanCompare } });
    }

    function handlePageClick(d) {
        console.log("handlePageClick::::::::::::::::::::::::", d, "hola")
        setOffset(d.selected)
    }

    useEffect(() => {
        getFilterTypesHead();
        getCPlanes();
        getRegiones();
        getFilterTypes();

        // getFilterOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(dataCPlanesBkHead.length && dataFilterTypesBK.length && !preFilterRealizo){
            
            setPreFilterRealizo(true)

            let planesFilter = dataCPlanesBkHead.filter(p => {
                return p.lstFiltrosxPlan?.find( l => dataFilterTypesBK.find(f => f.id === l.fi_OPCION_FILTRO))
            })
            let pageCountVal = dataCPlanes.length ? (Math.ceil(dataCPlanes.length / perPage)) : 1;
            
            setdataCPlanes(planesFilter)
            setdataCPlanesBk(planesFilter)
            setdataCPlanesBkHead(planesFilter)
            getMinMaxPrice(planesFilter)
    
            setPageCount(pageCountVal)
            setPerPage(6)
        }     
            
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataFilterTypesBK,dataCPlanesBkHead])


    useEffect(() => {

        let preFilter = localStorage.getItem('preFilter') ? localStorage.getItem('preFilter').split(",") : '';
        console.log("preFilter::::::::::::::::::::::::", preFilter)
        if (preFilter.length) {
            let FilterId = parseInt(preFilter[1].split(":")[1])
            let filterOption = preFilter[1].split(":")[0]
            console.log("preFilter length::::::::::::::::::::::::", preFilter, FilterId, filterOption)
            if (filterOption === "FilterId") {
                let newArrayChecks = dataFilterTypes.map((filt, index) => {
                    if (filt.id === FilterId) {
                        filt.checked = true
                    }
                    return filt;
                })
                console.log("FilterId === 1::::::::::::::::::::::::", preFilter, FilterId, filterOption, newArrayChecks)
                setOptionFilter('')
                if (dataCPlanesBk?.length) {
                    console.log("dataCPlanesBk?.length............................... type 1", preFilterRemove, filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                    if (preFilterRemove) {
                        console.log("preFilter............................... type 1", filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                        getFilterPlansMulti(rangePriceState, newArrayChecks, filterComuna, '', inputSearch)
                        localStorage.removeItem('preFilter')
                        setPreFilterRemove(!preFilterRemove)
                        console.log("preFilter............................... removeItem 1")
                    }
                }
            } else if (filterOption === "filterOption") {
                console.log("FilterId === 2::::::::::::::::::::::::", preFilter, FilterId, filterOption)
                setOptionFilter(filterOption)

                if (dataCPlanesBk?.length) {
                    if (preFilterRemove) {
                        console.log("preFilter............................... type 2", filterOption, dataCPlanesBk, dataCPlanes)
                        getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, filterOption, inputSearch)
                        localStorage.removeItem('preFilter')
                        setPreFilterRemove(!preFilterRemove)
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCPlanesBk, pageCount])

    function calculateInitElementShow() {
        const result = offset * perPage
        console.log(result, "calculateInitElementShow")
        return result
    }

    function calculateFnElementShow() {
        console.log(calculateInitElementShow() + perPage, "calculateFnElementShow")
        return calculateInitElementShow() + perPage
    }

    function getCalculatePageCount() {

        let pageCountVal = dataCPlanes?.length ? (Math.ceil(dataCPlanes.length / perPage)) : 1;
        return pageCountVal
    }

    function onChangeOptions(e) {
        let OrdHigherLower = e.target.value
        setOptiondHigherLower(OrdHigherLower)
        getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch, OrdHigherLower)
        console.log("onChangeOptions:", e.target.value, e)
    }


    const PlayPLanData = dataCPlanes.length ? dataCPlanes.slice(calculateInitElementShow(), calculateFnElementShow()).map((item, index) => (
        <div key={uuid()} className="c23Item" data-idplan={item.fi_PLAN}>
            <General2OneCardForMonths
                key={uuid()}
                title={item.fc_TEXTO_CAJA}
                titlestyle={item.fc_COLOR_CAJA ? item.fc_COLOR_CAJA.toLowerCase() : null}
                name={item.fc_NOMBRE}
                changeCompare={handleChangeCompare}
                fi_PLAN={item.fi_PLAN}
                fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                fi_ID_INTERNET={item.fi_ID_INTERNET}
                fi_CATEGORIA={item.fi_CATEGORIA}
                fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                fc_NOMBRE={item.fc_NOMBRE}
                fc_DESCRIPCION={item.fc_DESCRIPCION}
                fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                fi_PRECIO_PLAN={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(item.fi_PRECIO_PLAN) ? item.fi_PRECIO_PLAN+".00" : item.fi_PRECIO_PLAN.toFixed(2)} />}
                fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={item.fc_PRECIO_TACHADO.includes(".") ? item.fc_PRECIO_TACHADO : item.fc_PRECIO_TACHADO+".00" } />}
                Discount={item?.fc_PRECIO_TACHADO > 0 && parseInt(item.fc_PRECIO_TACHADO) !== parseInt(item.fi_PRECIO_PLAN) ? <NumberFormat displayType={'text'} value={(100 - (item.fi_PRECIO_PLAN * 100) / item.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
                fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                fc_URL_DETALLE={item.fc_URL_DETALLE}
                fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                fi_ORDEN={item.fi_ORDEN}
                fi_ACTIVO={item.fi_ACTIVO}
                fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                fi_BAN_ENPN={item.fi_BAN_ENPN}
                fi_BAN_ENPS={item.fi_BAN_ENPS}
                fi_BAN_ESPN={item.fi_BAN_ESPN}
                fi_BAN_ESPS={item.fi_BAN_ESPS}
                fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                fc_TITULO_PROMO={item.fc_TITULO_PROMO}
                Caracteristicas={item.caracteristicas}
                caracteristicasPromocion={item.caracteristicasPromocion}
                Acordeon={item.acordeon}
                lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                keysPlanCompare={keysPlanCompare}
                fi_INCLUIR_SECCION={item.fi_INCLUIR_SECCION}
                fc_ETIQUETA_ROJA={item.fc_ETIQUETA_ROJA}
                fc_TITULO_SECCION={item.fc_TITULO_SECCION}
                fc_DESCRIPCION_SECCION={item.fc_DESCRIPCION_SECCION}
                fc_TEXTO_BOTON={item.fc_TEXTO_BOTON}
                fc_TARGET_BOTON={item.fc_TARGET_BOTON}
                fc_URL_BOTON={item.fc_URL_BOTON}
                fc_DESCRIPCION_OFERTA={item.fc_DESCRIPCION_OFERTA}
                fc_PLAN_ICONO={item.fc_PLAN_ICONO}
                dataChannelsBk={dataChannelsBk}
                lstFiltrosxPlan={item?.lstFiltrosxPlan.length> 0 ? item.lstFiltrosxPlan : null}
                dataCategorias={dataCategorias}
                fc_texto_12_meses={item?.fc_TXT_12_MESES}
                fc_texto_24_meses={item?.fc_TXT_24_MESES}
                fc_texto_sin_contrato={item?.fc_TXT_SIN_CONTRATO}
            />
            {/* <PlayPlanCardMol
                key={uuid()}
                title={item.fc_TEXTO_CAJA}
                titlestyle={item.fc_COLOR_CAJA.toLowerCase()}
                name={item.fc_NOMBRE}
                changeCompare={handleChangeCompare}
                fi_PLAN={item.fi_PLAN}
                fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                fi_ID_INTERNET={item.fi_ID_INTERNET}
                fi_CATEGORIA={item.fi_CATEGORIA}
                fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                fc_NOMBRE={item.fc_NOMBRE}
                fc_DESCRIPCION={item.fc_DESCRIPCION}
                fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                fi_PRECIO_PLAN={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={item.fi_PRECIO_PLAN} />}
                fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={item.fc_PRECIO_TACHADO} />}
                fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                fc_URL_DETALLE={item.fc_URL_DETALLE}
                fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                fi_ORDEN={item.fi_ORDEN}
                fi_ACTIVO={item.fi_ACTIVO}
                fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                fi_BAN_ENPN={item.fi_BAN_ENPN}
                fi_BAN_ENPS={item.fi_BAN_ENPS}
                fi_BAN_ESPN={item.fi_BAN_ESPN}
                fi_BAN_ESPS={item.fi_BAN_ESPS}
                fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                Caracteristicas={item.caracteristicas}
                Acordeon={item.acordeon}
                lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                keysPlanCompare={keysPlanCompare}
            /> */}
        </div>
    )) : null

    // let perPage = 6;
    const onSubmitFilter = data => {
        console.log('Submit filters:', data);
    }

    let rangePrice = {
        min: rangePriceState.min,
        max: rangePriceState.max,
    }

    const optionsRegiones = dataRegiones.length ? dataRegiones.map((item, index) => (
        <option key={uuid()} value={item.value}>{item.label}</option>
    )) : null

    const [velocidadesSeleccionadas, setVelocidadesSeleccionadas] = useState([]);

    useEffect(() => {
        console.log(velocidadesSeleccionadas, "velocidadeSeleccionadas")

        
    }, [velocidadesSeleccionadas])
    const [velocidadesInternet, setVelocidadInternet] = useState([])



    const filterPlansByInternetVelocity = (velocidad, list, canal, setCheckboxes, setCounterChannels = () => {}) => {
        
        let lista = list ? list : dataCPlanesBk;
        setVelocidadesSeleccionadas(currentValue => {
            if(currentValue.indexOf(velocidad) > -1) {
                currentValue.splice(currentValue.indexOf(velocidad), 1);
            }else if(velocidad){
                currentValue.push(velocidad);
            }

            console.log(velocidad, "pruebasvelodi")
            return currentValue;
        });


        let filtrados = lista?.filter(plan => {
            let existe = false;

            plan.caracteristicas.filter(caracteristica => {
                let estaEnLasVelocidades = false;
                let caracteristicaVelocidad = caracteristica.fc_VALOR;

                if(caracteristicaVelocidad?.includes("/")) {
                    const regex = /\b\d{1,8}\s?MB\b/;
                    const match = caracteristicaVelocidad.match(regex);
    
                    if (match) {
                        console.log(match[0]);  // Output: 50MB
                        caracteristicaVelocidad = match[0]
                    }
                }


                velocidadesInternet.forEach((velocidad) => {
                    if(velocidad.valor === caracteristicaVelocidad && velocidad.checked && (caracteristica.fc_TITULO === "Wi-Fi" || caracteristica.fc_TITULO === "Velocidad")) {
                        estaEnLasVelocidades = true;
                    }
                })

                if(estaEnLasVelocidades && (caracteristica.fc_TITULO === "Wi-Fi" || caracteristica.fc_TITULO === "Velocidad")) {
                    existe = true;
                }
                
                return 1;
            });

            console.log(existe, "filtrostextzzzzzzzzzz")

            return existe;
        });

        console.log("console.log", filtrados)
        if(!filtrados.length) {
            filterPlansByChannels(canal, setCheckboxes, lista);
            // setdataCPlanes(lista);
        }else{
            // setdataCPlanes(filtrados);

            filterPlansByChannels(canal, setCheckboxes, filtrados);
        }
        setCounterChannels()
    }

    console.log('dataFilterTypes', dataFilterTypes, pageCount);
    const displayCompare = localStorage.getItem('fi_servicio')  === "3"  ? "" : "";
    const [resetPage, setResetPage] = useState(true);

    function filterPlansByChannels(canal, checkboxes, lista) {
        console.log("listachannels", lista, canal)
        let list = lista ? lista: dataCPlanesBk;
        if(checkboxes == undefined) {
            console.log("undefffffide")
            setdataCPlanes(list)
            return;
        }
        
        // checkboxes = checkboxes.map(channel => {
        //     if(canal == channel.canal) {
        //         channel.checked = !channel.checked;
        //     }

        //     return channel;
        // })


        
        let todosFalse = true;
        console.log("checboxesssss", checkboxes)
            checkboxes.forEach(canal => {
            if(canal.checked) {
                todosFalse = false;
            }
        })

        if(!checkboxes.length || todosFalse) {
            console.log(lista, "holasssssa")
            setdataCPlanes(lista)
            return
        }

        let canalesSeleccionados = checkboxes.filter(canales => canales.checked).map(canales => canales.lstOpcionFiltros);
        console.log(list, "condicionnnnnnn")

        if(!canalesSeleccionados.length) {
            setdataCPlanes(lista)
            return
        }
        
        
        let newPlans = list.filter(plan => {
            let contieneCanal = false;
            
            for(const opcionFiltros of canalesSeleccionados) {
                for(const opcionFiltro of opcionFiltros) {
                    if(plan.lstFiltrosxPlan.map(filter => filter.fi_OPCION_FILTRO).includes(opcionFiltro.fi_opcion_filtro)) {
                        contieneCanal = true;
                        break;
                    }
                }
            }
            
            return contieneCanal;
        })
        setdataCPlanes(newPlans)
        console.log("Entrooooo", checkboxes)
    }
    const [checkboxes, setCheckboxes] = useState([])
    return (

        dataToItems?.items && !regresaPlanes
            ?
            <C25PeopleOrg
                key={uuid()}
                dataCompare={dataToItems}
                resetHandleClick={resetHandleClick}
                removeItemHandleClick={removeItemHandleClick}
                setRegresaPlanes={setRegresaPlanes}
            />
            :
            <section className='c23Wrap'>
                {/* <BreadcrumbMol 
                    backToText='Volver a Servicios Hogar'
                /> */}
                <div className="container">
                    <div className="c23">
                        <div className="c23Fil">
                            <ServiceFilter
                            velocidadesInternet = {velocidadesInternet}
                            setVelocidadInternet={setVelocidadInternet}
                            checkboxes={checkboxes}
                            setCheckboxes={setCheckboxes}
                            setCanalContext={setCanalContext}
                            canalContext={canalContext}
                            dataCPlanes={dataCPlanes}
                            dataChannelsBk={dataChannelsBk}
                            filterPlansByChannels={filterPlansByChannels}
                                filterPlansByInternetVelocity={filterPlansByInternetVelocity}
                                dataCPlanesBk={dataCPlanesBk}
                                onSubmit={onSubmitFilter}
                                rangePrice={rangePrice}
                                showFilter={showFilter}
                                setShowFilter={setShowFilter}
                                // dataRegiones={dataRegiones}
                                optionsRegiones={optionsRegiones}
                                dataFilterTypes={dataFilterTypes}
                                dataFilterTypesChilds={dataFilterTypesChilds}
                                dataFilterTypesHead={dataFilterTypesHead}
                                handleChangeFilterPrice={handleChangeFilterPrice}
                                getPlanesByComuna={getPlanesByComuna}
                                getPlanesByCheckBox={getPlanesByCheckBox}
                                getPlanesByCheckBoxChilds={getPlanesByCheckBoxChilds}
                                getPlanesByCheckBoxHead={getPlanesByCheckBoxHead}
                                // keysTypeCompare={keysTypeCompare}
                                counterFilters={counterFilters + counterFiltersHead + counterChannelFilters + counterVelocityFilters}
                                setCounterChannelFilters={setCounterChannelFilters}
                                setCounterVelocityFilters={setCounterVelocityFilters}
                                clearFilters={clearFilters}
                            />
                        </div>
                        <div className="c23Cont">
                            <Title
                                tag={TitleTag.H2}
                                style={TitleStyle.H2}
                                className='c23HeaderTit'
                            >
                                {
                                    localStorage.getItem('titulo_seccion') ? localStorage.getItem('titulo_seccion') : Parser("&nbsp;")
                                }
                            </Title>
                            <div className="c23Bar">
                                <div className="c23BarDrop">
                                    <span className="select">
                                        <select value={optiondHigherLower} onChange={(e) => { onChangeOptions(e) }}>
                                            <option value='' disabled>Ordenar por:</option>
                                            <option value='1'>Precio: Menor a mayor</option>
                                            <option value='2'>Precio: Mayor a menor</option>
                                        </select>
                                    </span>

                                </div>
                                <div className="c23BarSearch">
                                    <SearchField
                                        onChange={e => onChangeInputSearch(e)}
                                        value={inputSearch}
                                    />

                                </div>
                                <div className="c23BarAct">
                                    <Button
                                        onClick={e => onHandleClickSearch(e)}
                                    >
                                        Buscar
                                    </Button>
                                </div>
                            </div>

                            {displayCompare?
                            <div className="c23Header">
                                <div className='c23HeaderFilter' onClick={() => { setShowFilter(!showFilter) }}>

                                    <p>Filtros <i className='ico-sliders'></i></p>

                                </div>
                                <div className="c23HeaderComp">
                                    {
                                       false && displayCompare === ""
                                        ?
                                        <>
                                        <div className="c23HeaderCompRad">
                                            <InputSelect
                                                type={InputSelectType.RADIO}
                                                text=''
                                                name='comparee[0]'
                                                className=''
                                                disabled={true}
                                                checked={keysPlanCompare[0] ? true : false}
                                            />
                                            <InputSelect
                                                type={InputSelectType.RADIO}
                                                text=''
                                                name='comparee[1]'
                                                className=''
                                                disabled={true}
                                                checked={keysPlanCompare[1] ? true : false}
                                            />
                                            <InputSelect
                                                type={InputSelectType.RADIO}
                                                text=''
                                                name='comparee[2]'
                                                className=''
                                                disabled={true}
                                                checked={keysPlanCompare[2] ? true : false}
                                            />
                                            <InputSelect
                                                type={InputSelectType.RADIO}
                                                text=''
                                                name='comparee[3]'
                                                className=''
                                                disabled={true}
                                                checked={keysPlanCompare[3] ? true : false}
                                            />
                                            <InputSelect
                                                type={InputSelectType.RADIO}
                                                text=''
                                                name='comparee[4]'
                                                className=''
                                                disabled={true}
                                                checked={keysPlanCompare[4] ? true : false}
                                            />
                                        </div>
                                         <div className="c23HeaderCompBtn">

                                            <Button
                                                category={ButtonCategory.TRANS_GRIS}
                                                onClick={keysPlanCompare.length >= 2 ? e => routeChange(e) : null}
                                            >
                                                Comparar servicios
                                            </Button>
                                        </div>
                                        </>
                                        : null
                                    }
                                </div>
                            </div>:null
                             }

                            <div className="c23Items">
                                {
                                    PlayPLanData
                                }

                            </div>
                            <div className="c23Pag">
                                {
                                    dataCPlanes.length
                                        ?
                                        <PaginationMol
                                            pageCount={getCalculatePageCount()}
                                            onPageChange={handlePageClick}
                                            initialPage={offset}
                                            forcePage={0}
                                            resetPage={resetPage}
                                        />
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default C23OneCardForMonths
